// extracted by mini-css-extract-plugin
module.exports = {"mainUiBlock":"_28e_b","tooltipContainerWrapper":"_3tXHF"};